<script setup lang="ts">
import type { IService } from '@types';
import { ArrowLeft, ArrowRight } from '@ui/icons/filled';

const props = withDefaults(defineProps<{
  services?: IService[];
  defaultImage?: string;
}>(), {
  services: () => [],
  defaultImage: '',
});

const serviceId = defineModel<number>('serviceId');

const slideNumber = computed<number>({
  get: () => props.services.findIndex(s => s.id === serviceId.value),
  set: (index: number) => {
    const id = +props.services[index]?.id;
    if (id !== serviceId.value) serviceId.value = id;
  },
});

defineEmits(['open:images']);
</script>

<template lang="pug">
.service-scroll.p-8-0.flex-shrink-0
  UiIconsIconButton.icon-button.prev-slide.s-44.p-14(:name="ArrowLeft")
  UiSlider(v-model:index="slideNumber" slides="auto" :items="services" :pagination="false" :slideToClickedSlide="false")
    template(v-slot="{item, isActive}")
      ServiceScrollSelectorCard(:service="item" :defaultImage="defaultImage" :active="isActive" @open:images="$emit('open:images', $event)")
  UiIconsIconButton.icon-button.next-slide.s-44.p-14(:name="ArrowRight")
</template>

<style scoped lang="scss">
.service-scroll {
  background: #F8F8F9;
  border-bottom: 1px solid #EDEDF2;
  overflow: auto;
  position: relative;

  @screen sm {
    &:before,
    &:after {
      content: '';
      position: absolute;
      pointer-events: none;
      background: linear-gradient(90deg, #FCFCFC 32.84%, rgba(255, 255, 255, 0) 100%);
      --uno: w-128 t-0 b-0 z-index-2;
    }

    &:after {
      --uno: r-0;
      transform: scaleX(-1);
    }
  }
}

.icon-button {
  display: none;
  background: #DBEEFF;
  top: calc(50% - 22px);
  --uno: position-absolute z-index-3 br-14;

  &:not(.disabled) {
    color: #3870FF;
    background: #ECF6FF;
  }

  &.prev-slide {
    --uno: l-16;
  }

  &.next-slide {
    --uno: r-16;
  }

  @screen sm {
    display: unset;
  }
}
</style>